<template>
  <div>
    <PlantillaContenido>
      <div slot="titulo"> 
      <i class="fas fa-folder icon"></i>
        Tipos de documentos
      </div>
      <div slot="breadCrumb">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul> 
            <li>
              <router-link :to="{name:'administratorHome'}" >
                <span >
                  <i class="fas fa-home icon"></i>                  
                   inicio
                </span>
              </router-link>
            </li>
            <li class="is-active">
              <router-link :to="{name: 'documentType'}">
                <span>
                 <i class="fas fa-folder icon"></i>
                  Tipos de documentos
                </span>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>

      <div slot="contenido">
        <div class="box">

          <createDocumentType 
          v-if="isComponentModalActive"
          :isComponentModalActive="isComponentModalActive"
          :closeBasic="closeBasic"
          :chargeDocumentTypeList="chargeDocumentTypeList"
          :document_type_id="document_type_id">
          </createDocumentType>
          <b-button type="is-primary is-small" @click="openBasic()">Crear Tipo de Documento</b-button>

          <b-table type="is-primary"
            :data.sync="listDocumentType.data"
            :loading="loading"            
            :is-fullwidth="true"
            
            paginated
            backend-pagination
            :total="listDocumentType.total"
            :per-page="listDocumentType.per_page"
            @page-change="chargeDocumentTypeList"
          >
            <template slot-scope="props">
              <b-table-column searchable field="name" label="Nombre">{{ props.row.name }}</b-table-column>

              <b-table-column label="Action">
                        <b-button type="is-primary is-small" @click="editBasic(props.row.id)">Editar</b-button>

              </b-table-column>
            </template>
          </b-table>
          
        </div>
      </div>
    </PlantillaContenido>
  </div>
</template>
<script>
import PlantillaContenido from '../../../../template/PlantillaContenido'
import createDocumentType from '../../../../components/manteiners/documentType/create';
import {DocumentTypeService} from "../../../../services/models/document_type";

export default {
  components: {
    PlantillaContenido,
    createDocumentType
  },
  data() {
    return {
      document_type_id: null,
      listDocumentType: [],
      isFullPage: true,
      isComponentModalActive: false,
      isPaginated: true,
      loading: false,
      isPaginationSimple: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 5
    };
  },
  mounted: function() {
    this.chargeDocumentTypeList();
  },
  methods: {
    openBasic() {
      this.isComponentModalActive = true;
    },
    closeBasic() {
      this.document_type_id = null;
      this.isComponentModalActive = false;
    },
    editBasic(id) {
      this.document_type_id = id;
      this.isComponentModalActive = true;
    },
    async chargeDocumentTypeList() {
      this.loading = true;
      this.listDocumentType = [];
      const {data} = await DocumentTypeService.getAll();
      this.listDocumentType = data;
      this.loading = false;
    }
  },
  
};
</script>

